import * as React from "react";
import { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputBase,
  Radio,
  RadioGroup,
  Snackbar,
  Tooltip,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,

} from "@material-ui/core";
import { alpha, createTheme, makeStyles, Theme, ThemeProvider } from "@material-ui/core/styles";
import { primaryBlue, primaryGray, white } from "src/components/colors";
import { environment } from "src/environments/environment";

import AddNewDecoder from "./CreateCodec";
import ReactSwitch from "react-switch";
import { useHistory } from 'react-router-dom';
import { Alert } from "@material-ui/lab";
import axios from "axios";

import useStyles from "src/app/maintenance/assets/styles";
import { AddSensors } from "./AddSensorComponent";
import { addSensor, getAllSensors } from "src/app/maintenance/test-automation/components/apiHelper";
import { capitalizeWords } from "src/app/utils";
import Cookies from "js-cookie";
import{uploadFlowChart,flowChartConfig} from 'src/app/product-types/api-helper/apiHelper'
import { hasPackagePermission } from "../../authentication/package.permission";
import Circle from "src/components/sub-components/Circle";
import { AddIconLarge, CloseIcon, DownArrow, QuestionIcon, UpArrow } from "src/components/Icons";
import Step2RemoteOTAConfig from "./Step2RemoteOTAConfig";

export function DefineProductTypeComponent(props) {
  const classes = local();
  const style = useStyles();
  const history = useHistory();
  const STEPS = [
  {
    text: "Define Product Type",
    activate: true,
  },
  {
    text: "OTA/RM Configuration",
    activate: false,
  }
];

  const [steps, setSteps] = useState(STEPS);
  const [mainstep, setMainstep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showSensorPopup, setShowSensorPopup] = useState(false);
  const [showActuatorPopup, setShowActuatorPopup] = useState(false);
  const [showSensorOptions, setShowSensorOptions] = useState(false);
  const [showActuatorOptions, setShowActuatorOptions] = useState(false);
  const [isConnectionDropDown, setIsConnectionDropDown] = useState(false);
  const [isProtocolDropDown, setIsProtocolDropDown] = useState(false);


  const [isCodecDropDown, setIsCodecDropDown] = useState(false);
  const [addAnotherProduct, setAddAnotherProduct] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isToggled, setIsToggled] = useState(true);
  const [otaUpgradable, setOtaUpgradable] = useState(true);
  const [isTranscoding, setIsTranscoding] = useState(false);
  const [showCreateCodecDialog, setShowCreateCodecDialog] = useState(false);
  const [toaster, setToaster] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredSensors, setFilteredSensors] = useState([]);
  const [isAddSensorPopup,setIsAddSensorPopup] = useState(false)

  const [sensors, setSensors] = useState([]);
  const [actuators, setActuators] = useState([]);
  const [sensorsOfDevice, setSensorsOfDevice] = useState([]);
  const [actuatorsOfDevice, setActuatorsOfDevice] = useState([]);
  const [step, setStep] = useState("select");
  const [codecs, setCodecs] = useState([]);
  const [selectedCodec, setSelectedCodec] = useState('');
  const [productName, setProductName] = useState("");
  const [protocol, setProtocol] = useState("");
  const [dataFormat, setDataFormat] = useState("");
  const [connectivity, setConnectivity] = useState("");
  const [persistenceValue, setSelectedPersistence] = useState('');
  const [codecToSend, setCodecToSend] = useState("");
  const [remotelyConfigurable, setRemotelyConfigurable] = useState(true);
  const [newSensorName,setNewSensorName] = useState("")
  const [newSensorCode,setNewSensorCode] = useState("")
  const [sensorErrors,setSensorErrors] = useState({
    sensorNameError:null,
    sensorCodeError:null
  })

  //Error Messages
  const [errors, setErrors] = useState({
    productNameError: null,
    sensorsError: null,
    actuatorsError: null,
    protocolError: null,
    dataFormatError: null,
    connectivityError: null,
    persistenceError: null,
    parametersError:null,
    codecError:null,
    rmConfigError:null,
    rmAckError:null,
    otaError:null,
    otaAckError:null
  })
  const theme = createTheme({
    typography: {
      body1: {
        fontSize: '14px', 
        fontFamily:'poppins'
      },
    },
  });

  const connectivityOptions = ["WIFI", "GSM"];
  const protocolOptions = hasPackagePermission('Protocol') ? ["MQTT", "HTTP"] : ["MQTT"];


  //add version states
  const [productVersion, setProductVersion] = useState("");
  const [binFile, setBinFile] = useState<File | null>(null);

  const [flowchartFileList, setFlowchartFileList] = useState([]);
  const [flowChart, setFlowChart] = useState<File | null>(null);
  const [flowChartName, setFlowChartName] = useState("");

  const [versionError, setVersionError] = useState({error:false,errorMsg:""});
  const [binError, setBinError] = useState({ error: false, errorMsg: "" });
  const [availableBinfiles, setAvailableBinFiles] = useState([]);
  const [flowChartError,setFlowChartError]=useState({error:false,errorMsg:""});
  const [flowChartNameError,setFlowChartNameError]=useState({error:false,errorMsg:""});

  //final states that should send to BE ***************
  const [parameters, setParameters] = useState([]);
  const [parametersAddedError, setParametersAddedError] = useState(false);
  const [parameterError, setParameterError] = useState({
    error: false,
    errorMsg: "",
  });
  const [open, setOpen] = useState(true);
  const [openOTA, setOpenOTA] = useState(false);

  const [showNotAvailablePopup, setShowNotAvailablePopup] = useState({
    open: false,
    featureName: '',
  });

    
   const [otaAckTopic,setotaAckTopic]=useState("");
   const [rmAckTopic,setrmAckTopic]=useState("")
   const [otaRequestTopic,setotaRequestTopic]=useState("")
   const [rmConfigTopic,setrmConfigTopic]=useState("")
  



    useEffect(() => {
      axios.get(`${environment.host}/core/product/configDetails`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
        .then((response) => {
          if (response.data.content !== undefined) {
            setAvailableBinFiles(response.data.content.availableBinFiles[0]); 
          }
        })
        .catch((err) => {
          console.error("Failed to fetch available bin files:", err);
        });
    }, []);


    useEffect(() => {
        updateStepActivation(mainstep);
    }, [mainstep]);
    
    function updateStepActivation(currentStep) {
        const updatedSteps = steps.map((step, index) => ({
            ...step,
            activate: index === currentStep,
        }));
        setSteps(updatedSteps);
    }


  // Event listener to handle clicks outside dropdowns
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        showSensorOptions ||
        showActuatorOptions ||
        isConnectionDropDown ||
        isProtocolDropDown ||

        isCodecDropDown
      ) {
        if (
          !event.target.closest('.sensor-dropdown') &&
          !event.target.closest('.actuator-dropdown') &&
          !event.target.closest('.connection-dropdown') &&
          !event.target.closest('.protocol-dropdown') &&
          !event.target.closest('.codec-dropdown')
        ) {
          setShowSensorOptions(false);
          setShowActuatorOptions(false);
          setIsConnectionDropDown(false);
          setIsProtocolDropDown(false);
          setIsCodecDropDown(false);
        }
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [
    showSensorOptions,
    showActuatorOptions,
    isConnectionDropDown,
    isProtocolDropDown,
    isCodecDropDown,
  ]);

  useEffect(() => {
    fetchCodecs();
    fetchMetaData();
    getAllSensores()
  }, []);

  // Fetch MetaData from the API endpoint
  const fetchMetaData = () => {
    setLoading(true);
    const accessToken = Cookies.get("ACCESS_TOKEN");
    axios.get(`${environment.host}/core/meta-data`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setActuators(response.data.content.actuators.sort((a, b) => (a.name < b.name ? -1 : 1)));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching metadata:', error);
        setLoading(false);
      });
  };

  const getAllSensores =async () =>{
    try{
      const response =await getAllSensors()
      if(response){
        const sortedSensors = response.sort((a, b) => (a.codeValue < b.codeValue ? -1 : 1));
        setSensors(sortedSensors);
        setFilteredSensors(sortedSensors);
      }
    }catch(error){
      setToaster(true)
      setReqSuccess(false)
      setErrorMessage(error.message)
    }
  }

  // Fetch product types from the API endpoint
  const fetchCodecs = async () => {
    const accessToken = Cookies.get("ACCESS_TOKEN");
    await axios.get(`${environment.host}/core/codec?returnType=LIST`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setCodecs(response.data.content);
      })
      .catch((error) => {
        console.error('Error fetching codecs:', error.response.statusText);
      });
  };



  //API endpoint for the save product type
  const saveProductType = async (binFile?: File) => {
    checkTranscoding();
  
    const dependencyMap = new Map();
    const deviceParameterConfiguration = {};
    const versions = [];
  
    parameters.forEach(param => {
      const paramId = param.parameterId;
      const joinParameters = param.joinParameter;
      if(joinParameters){
      joinParameters.forEach(joinParamId => {
        if (!dependencyMap.has(joinParamId)) {
          dependencyMap.set(joinParamId, []);
        }
        const joinList = dependencyMap.get(joinParamId);
        if (joinList && !joinList.includes(paramId)) {
          joinList.push(paramId);
        }
  
        if (!dependencyMap.has(paramId)) {
          dependencyMap.set(paramId, []);
        }
        const paramList = dependencyMap.get(paramId);
        if (paramList && !paramList.includes(joinParamId)) {
          paramList.push(joinParamId);
        }
      });
     }
    });
  
    const joinParametersObj = {};
    Array.from(dependencyMap).forEach(([key, value]) => {
      joinParametersObj[key] = value;
    });
  
    const version = {};
    if(!remotelyConfigurable||!otaUpgradable){
    version["versionNum"] = (productVersion.length>0)?productVersion:"0.0.0"; //allow base version only when version is valid and binfile added
    version["status"] = "APPROVED";  //remove 
    version["remoteConfigurations"] = parameters.map(({ joinParameter, ...rest }) => rest);
    version["joinParameters"] = joinParametersObj;
    version['majorVersionUpgrade']=false;
    if(binFile&&productVersion.length>0&&flowChart &&flowChartName.length>0){
    let flowChartUpload=await uploadFlowChart(flowChart,flowChartConfig);
    console.log('url,',flowChartUpload);
    if(flowChartUpload.ok){
    version['flowChartURL']== flowChartUpload.url
    version['flowChartFileName']=flowChartName;
    }
    }
    versions.push(version);}
  
    const productTypeDTO = {
      productName: productName,
      sensorCodes: sensorsOfDevice.map(sensor => sensor.code),
      actuatorCodes: actuatorsOfDevice.map(actuator => actuator.code),
      persistence: false,
      protocol: protocol,
      connectivity: connectivity,
      codecName: codecToSend,
      transcoder: true,
      otaUpgradable: true,
      remotelyConfigurable: true,
      dataFormat: dataFormat,
      versions: versions,
      ...(!remotelyConfigurable && {    remoteConfigTopic:rmConfigTopic,
      remoteConfigAckTopic:rmAckTopic}),
      ...(!otaUpgradable&&{otaAckTopic:otaAckTopic,
      otaRequestTopic:otaRequestTopic})
    };
  
    if (persistenceValue === 'true') {
      productTypeDTO.persistence = true;
    }
  
    if (isToggled === true) {
      productTypeDTO.transcoder = false;
    }
  
    if (otaUpgradable === true) {
      productTypeDTO.otaUpgradable = false;
    }
  
    if (remotelyConfigurable === true) {
      productTypeDTO.remotelyConfigurable = false;
    }
  
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(productTypeDTO)], { type: "application/json" });
    formData.append("productTypeDTO", jsonBlob);
  
    if (binFile && productVersion.length>0) {
      formData.append("binFile", binFile);
    }
  
    try {
      const response = await axios.post(`${environment.host}/core/product/productType`, formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`
        }
      });
  
      if (response.data.message === 'Success') {
        setReqSuccess(true);
        setErrorMessage('Product Type Added Successfully');
        setToaster(true);
        resetFormFields();
      }
  
      return response.data;
  
    } catch (error) {
      setLoading(false);
      setToaster(true);
      setReqSuccess(false);
      setTimeout(() => {
        setToaster(false);
      }, 4000);
  
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
        throw new Error(error.response.data.message);
      } else {
        setErrorMessage("Something went wrong");
        throw new Error("Something went wrong");
      }
    }
  };   

  const resetFormFields = () => {
    setProductName('');
    setSensorsOfDevice([]);
    setShowSensorPopup(false)
    setActuatorsOfDevice([]);
    setShowActuatorPopup(false)
    setConnectivity('');
    setProtocol('');
    setDataFormat('');
    setOtaUpgradable(true);
    setRemotelyConfigurable(true);
    setSelectedPersistence('');
    setCodecToSend('');
    setAddAnotherProduct(false);
    setIsSubmitted(false);
    setIsToggled(true);
    setIsTranscoding(false);
    setParameters([]);
  };

  const handleCloseToaster = () => {
    setToaster(false);
  };

  const redirectToHome = () => {
    resetFormFields();
    setTimeout(() => {
      history.push(addAnotherProduct ? `/DefineProductType` : ``)
    }, 2000);
  };
  const handleBack = () => {
    if (mainstep == 0) {
      resetFormFields();
      history.push(``);
    }
    else {
      setMainstep(0);
    }
  }
  const handleNext = () => {
    setIsSubmitted(true);
    const validationError = validateStepOne();

    setErrors(validationError)
    if (Object.keys(validationError).length > 0) {
      return;
    }
    setMainstep(1);
    }
  const validateStepOne = () => {
      let error: any = {}
      if (productName.trim() === "") {
        error.productNameError = "Product Name is Required"
      }
      else if (!isValidProductName(productName)) {
        error.productNameError = "Only letters, numbers, hyphens, and underscores allowed";
      }
      if (sensorsOfDevice.length == 0 && actuatorsOfDevice.length == 0) {
        if (sensorsOfDevice.length == 0) {
          error.sensorsError = "Sensors are Required"
        }
        if (actuatorsOfDevice.length == 0) {
          error.actuatorsError = "Actuators are Required"
        }
      }

      if (protocol.trim() === "") {
        error.protocolError = "Protocol is Required"
      }
      if (connectivity.trim() === "") {
        error.connectivityError = "Connection is Required"
      }

      if (persistenceValue === '') {
        error.persistenceError = "Persistence is Required"
      }
      if (isTranscoding && codecToSend === "") {
        error.codecError = "Codec is Required"
      }
      return error;

    }
  const handleSave = async () => {
    console.log('Save')
    let isError = false;
    setIsSubmitted(true);
    let validationError;
    if(mainstep==0){
      validationError=validateStepOne();
    }
    else{
     validationError = validationStep2();
    }
    setErrors(validationError)
    if (Object.keys(validationError).length > 0) {
      return;
    }
    setLoading(true);
    try {
      const response = await saveProductType(binFile);
      if (response.message === 'Success') {
        if (addAnotherProduct) {
          setLoading(false);
        } else {
          redirectToHome();
        }
      }
    } catch (error) {
      console.error('Error saving product type:', error);
      setLoading(false);
    }
  };

  const handleSensorPopup = () => {
    setIsAddSensorPopup(!isAddSensorPopup);
    setSensorErrors((prev)=>({
      ...prev,
      sensorCodeError:null,
      sensorNameError:null
    }))
  };
  const handleActuatorPopup = () => {
    setShowActuatorPopup(!showActuatorPopup);
  };
  const handleProtocolChange = (option) => {
    setProtocol(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      protocolError: null
    }));
  };
  const handleConnectivityChange = (option) => {
    setConnectivity(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      connectivityError: null
    }));
  };

  const handleCodecChange = (option) => {
    setCodecToSend(option);
  };
  const handleCodecCreation = (name) => {
    setCodecToSend(name);
  };
  const handleCheckboxChange = (event) => {
    setAddAnotherProduct(event.target.checked);
  };


    function isValidProductName(input) {
      const regex = /^[A-Za-z0-9_-]+$/;
      return regex.test(input);
  }
  const validationStep2 = () => {
    let error: any = {}
    
    if (!remotelyConfigurable && (!parameters || parameters.length === 0)) {
      error.parametersError = "Remote Config Parameters are Required";
    }

    if ((!otaUpgradable || !remotelyConfigurable) && dataFormat.trim() === "") {
      error.dataFormatError = "Data Format is Required"
    }

    if (!remotelyConfigurable && (rmConfigTopic.length === 0)) {
      error.rmConfigError = "Remote config  Topic is Required";
    }
    else if (!remotelyConfigurable && !hasExactlyOnePlaceholderBySegment(rmConfigTopic)) {
      error.rmConfigError = "Remote Topic  must have one {deviceId}";
    }
        if (!remotelyConfigurable && (rmAckTopic.length===0 )) {
      error.rmAckError = "Remote ack Topic is Required";
    }
        else if (!remotelyConfigurable && !hasExactlyOnePlaceholderBySegment(rmAckTopic)) {
      error.rmAckError = "Remote Topic  must have one {deviceId}";
    }
    if (!otaUpgradable && (otaRequestTopic.length === 0)) {
      error.otaError = "OTA Topic is Required";
    }
    else if (!otaUpgradable && !hasExactlyOnePlaceholderBySegment(otaRequestTopic)) {
      error.otaError = "OTA Topic  must have one {deviceId}";
    }
    if (!otaUpgradable && (otaAckTopic.length===0 )) {
      error.otaAckError = "OTA ack Topic is Required";
    }
    else if (!otaUpgradable && !hasExactlyOnePlaceholderBySegment(otaAckTopic)) {
      error.otaAckError = "OTA Topic  must have one {deviceId}";
    }

    if(!otaUpgradable&&productVersion.length==0){
           error.versionError = "version is required";
    }
    else if (!validateVersion(productVersion)) {
    error.versionError="version number invalid"
}
    if(!otaUpgradable&&!binFile){
           error.binFileError="binfile is required";
           setBinError({error:true,errorMsg:"binfile is required"});
    }
    else if(binFile && binFile.name &&availableBinfiles.some(name=>name === binFile.name)) {
      error.binFileError = "File already availble with this filename";
      setBinError({error:true,errorMsg:"File already availble with this filename"});

      }
        if(binFile){
      console.log(binFile.name, "name",availableBinfiles,availableBinfiles.some(name=>name === binFile.name));
    }

    return error
  }


const hasExactlyOnePlaceholderBySegment = (topic) => {
  const segments = topic.split("/");
  let deviceIdCount=0;

    for (const segment of segments) {
    if (segment === "{deviceId}") {
      deviceIdCount++;
    } else if (segment.includes("{") || segment.includes("}")) {
      return false; // any other placeholder is invalid
    }
  }

  return deviceIdCount === 1;
};
const validateVersion=(version)=>{
  return version.match("^(?!0+\\.0+\\.0+$)\\d+\\.\\d+\\.\\d+$");
}



  const handleSensorSelection = (sensorName) => {
    if (sensorName === 'AddSensor') {
      setShowSensorPopup(true);
    } else if(sensorName !== "") {
      const selectedSensor = sensors.find(sensor => sensor.codeValue === sensorName);
      if (selectedSensor && !sensorsOfDevice.some(sensor => sensor.codeValue === selectedSensor.codeValue)) {
        setSensorsOfDevice(prevSensors => [
          ...prevSensors,
          { name: selectedSensor.codeValue, code: selectedSensor.code }
        ]);
      }
      setErrors(prevErrors => ({
        ...prevErrors,
        sensorsError: null,
        actuatorsError: null
      }));
    }
    setSearchQuery('');
    setFilteredSensors(sensors);
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query === '') {
      setFilteredSensors(sensors);
    } else {
      const filtered = sensors.filter(sensor => sensor.codeValue.toLowerCase().includes(query.toLowerCase()));
      setFilteredSensors(filtered);
    }
  };

  const removeSensorFromDevice = (indexToRemove) => {
    setSensorsOfDevice(prevSensors =>
      prevSensors.filter((sensor, index) => index !== indexToRemove)
    );
  };

  const handleActuatorSelection = (actuatorName: string) => {
    if (actuatorName === 'AddSensor') {
      setShowActuatorPopup(true);
    } else {
      const selectedActuator = actuators.find(a => a.name === actuatorName);
      if (selectedActuator) {
        setActuatorsOfDevice(prev => [
          ...prev,
          { name: selectedActuator.name, code: selectedActuator.code }
        ]);
      }
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      actuatorsError: null,
      sensorsError: null,
    }));
  };

  const removeActuatorFromDevice = (indexToRemove) => {
    setActuatorsOfDevice(prevActuators =>
      prevActuators.filter((actuator, index) => index !== indexToRemove)
    );
  };

  const SensorPopup = () => {
    return (
      <Popup
        type="sensor"
        onClose={() =>
          setShowSensorPopup(false)
        } />
    );
  };
  const ActuatorPopup = () => {
    return (
      <Popup
        type="actuator"
        onClose={() =>
          setShowActuatorPopup(false)
        } />
    );
  };
  const Popup = ({ type, onClose }) => {
    return (
      <div style={{ color: 'black' }}>
        <div>
          <b>Need to add a {type === 'sensor' ? 'sensor' : 'actuator'}?</b> <br />
          Contact the admin for assistance!
        </div>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0px',
            right: '5px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <CloseIcon color='#2A7BEC'/>
        </button>
      </div>
    );
  };




  const showFeatureUnavailablePopup = (featureName) => {
    setShowNotAvailablePopup({
      open: true,
      featureName
    });
  };

  const handleChangeToggle = () => {
    handleTranscoding();
    setIsToggled(!isToggled)
    setIsCodecDropDown(false);
    setSelectedCodec("");
    setCodecToSend("");
    setStep("select");
  }
  const handleChangeOTAToggle = () => {
    const newValue = !otaUpgradable;
    setOtaUpgradable(newValue)
  }
  const handleCloseAddVersion=()=>{
    setOpenOTA(false)
  }
  const handleAddVersion=()=>{
    if (productVersion === "") {
      setVersionError({ error: true, errorMsg: `Version Required` });
      return;
    }
    else if(productVersion=="0.0.0"){
      setVersionError({
        error: true,
        errorMsg: `Invalid Version Number`,
      });
      return;
    }
    if (binFile) {
      

      if (!binFile.name.endsWith(".bin")) {
        setBinError({ error: true, errorMsg: "Invalid file type" });
        return;
      } else {
        setBinError({ error: false, errorMsg: "" });
      }
      if (availableBinfiles.some(name => name === binFile.name)) {
        setBinError({ error: true, errorMsg: "Filename already exists" });
        return;
      }
    }
    else{
      setBinError({ error: true, errorMsg: "Bin file is required" });
      return;
    }

    if((!flowChart && (flowChartName.length>0))){
          setFlowChartError({ error: true, errorMsg: "Flowchart file  is required" });
          return;
        }
    else{
      setFlowChartError({ error: false, errorMsg: "" });
    }
    if((flowChart && !(flowChartName.length>0))){
      setFlowChartNameError({ error: true, errorMsg: "Flowchart file name is required" });
       return;
    }

    if (!hasPackagePermission("OTAManger")) {
      showFeatureUnavailablePopup('OTA Manager')
    } else {
      setOpenOTA(false);
    }
  }

  const handleChangeRemoteToggle = () => {
    const newValue = !remotelyConfigurable;
    setRemotelyConfigurable(newValue);
  
  };
  
  
const handleTranscoding = () => {
    if (isToggled) {
      setIsTranscoding(true);
    }
  }

  const checkTranscoding = () => {
    if (isTranscoding) {
      if (codecToSend === "") {
        localStorage.setItem('transcodingIsPending', 'true');
      }
    }
  }
  const handleCreateCodecClick = () => {
    setStep("create");
    setShowCreateCodecDialog(!showCreateCodecDialog);
  };
  const handleSelectCodecClick = () => {
    setStep("select");
    setSelectedCodec("");
    fetchCodecs();
  };

  const successCallback = (message) => {
    if (message === "Success") {
      setLoading(false);
      setToaster(true);
      setErrorMessage('Codec Added Successfully');
      setReqSuccess(true);
    }
  }

  const isAddSensor = () =>{
    const isShowPopup = showSensorOptions
    if(isShowPopup == true){
      setNewSensorCode("")
      setNewSensorName("")
    }
    setShowSensorOptions(!showSensorOptions)
    setIsAddSensorPopup(false)
  }

  const sensorValidation = () =>{
    let errors :any = {}
    if(newSensorName == ""){
      errors.sensorNameError = 'Sensor name required'
    }else if(sensors.some(sensor => sensor.codeValue.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorNameError = 'Sensor name already exist'
    }
    if(newSensorCode == ""){
      errors.sensorCodeError = 'Sensor code required'
    }else if(sensors.some(sensor => sensor.code.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorCodeError = 'Sensor code already exist'
    }
    return errors
  }

  const handleSensorName = (event) =>{
    const value = event.target.value
    setNewSensorName(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorNameError : null
      }))
    }
  }

  const handleSensorCode = (event) =>{
    const value = event.target.value
    setNewSensorCode(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorCodeError : null
      }))
    }
  }

  const handleAddSensor = async() =>{
    const isValid = await sensorValidation();
    if(Object.values(isValid).length != 0){
      setSensorErrors(isValid)
      return;
    }
    setLoading(true)
    const data =[{
      code:newSensorCode.toUpperCase(),
      codeValue : capitalizeWords(newSensorName)
    }]
    console.log(data)
    try{
      const response = await addSensor(data)
      if(response){
        setToaster(true)
        setReqSuccess(true)
        setErrorMessage("Sensor Added Succesfully")
        getAllSensores()
        setIsAddSensorPopup(false)
      }
    }catch(error){
      setToaster(true)
      setReqSuccess(false)
      setErrorMessage(error.message)
    }finally{
      setLoading(false)
    }
  }

  

  return (
    <ThemeProvider theme={theme}>
      <div className={`testing`}>

        <Grid container className={style.senzmaticaStepsPage} >
          <div className={style.setupStepHeading} >
            STEP 0{mainstep + 1} 
          </div>
          <Grid container className={style.formContent}>

            <Grid container
              style={{
                textAlign: "center"
              }}>
              <Grid item xs={1} md={4}></Grid>

              {steps.map((step, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={1} md={1}>
                    <Grid container direction="column" alignItems="center">
                      <Grid item>
                        <Circle number={index + 1} active={step.activate} completed={steps.findIndex(s => s.activate) > index} />
                      </Grid>
                      <Grid item>
                        <Typography className={style.circleText}
                          style={{
                            color: step.activate ? primaryBlue : primaryGray,
                          }}
                        >
                          {step.text}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {index !== steps.length - 1 && (
                    <Grid item xs={1} md={2}>
                      <hr
                        style={{
                          marginTop: "18px",
                          marginLeft: "-20px",
                          marginRight: "-20px",
                          opacity: steps[index + 1].activate ? "1" : "0.12",
                        }}
                        color={
steps[index + 1].activate ? primaryBlue : "rgba(112, 112, 112, .12)"
}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
              <Grid item xs={1} md={4}></Grid>
            </Grid>

 <div style={{marginTop: '50px' ,width:"100%", padding:"24px", backgroundColor:"white"}}>
     {mainstep == 0 ? (<>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={12}>
                      <Typography className={style.typo}>
                        Product Name
                        <span className={style.required}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <FormControl className={style.inputProdAdd}>
                        <input
                          className={style.formInputNew}
                          type="text"
                          placeholder="Add Product Name"
                          value={productName}
                          onChange={(e) => {
                            setProductName(e.target.value);
                            setErrors(prevErrors => ({
                              ...prevErrors,
                              productNameError: null
                            }));
                          }}
                        />
                        {errors.productNameError && (
                          <span className="form-error">
                            {errors.productNameError}
                          </span>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>

              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={12}>
                      <Typography className={style.typo}>
                        Sensors
                        <span className={style.required}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className={`cloud-container ${showSensorPopup ? classes.popup : ''}`}>
                        {showSensorPopup ? (
                          <label className="no-data-available" style={{ width: "100%" }}>
                            <SensorPopup />
                          </label>
                        ) : (
                          <>
                            {sensorsOfDevice.length === 0 && (
                              <label className="no-data-available" style={{ width: "100%" }}>
                                No Sensor Added
                              </label>
                            )}
                            {sensorsOfDevice.map((sensor, index) => (
                              <Grid container key={index} className={style.cloudItem}>
                                <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                                <Grid item className={style.cloudItem_line}></Grid>
                                <Grid item className={style.cloudItem_text}>{sensor.name}</Grid>
                                <Grid item onClick={() => removeSensorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC' /></Grid>
                              </Grid>
                            ))}
                          </>
                        )
                        }
                      </div>
                      <FormControl className={`${style.inputProdAdd} sensor-dropdown`}>
                        <div className={style.formInputNew} onClick={isAddSensor}>
                          <span style={{ color: "grey" }}>
                            {showSensorOptions ? (
                              <InputBase
                                placeholder="Search Sensors"
                                style={{ fontFamily: "'Poppins',sans-serif", fontSize: '13px' }}
                                value={searchQuery}
                                onChange={handleSearchChange}
                                fullWidth
                                autoFocus
                              />
                            ) : (
                              <>Add Sensors</>
                            )}
                          </span>
                          {showSensorOptions ? <UpArrow /> : <DownArrow />}
                        </div>
                        {showSensorOptions && (
                          <Grid container className={classes.dropDownGrid}>
                            <Grid item xs={12} md={12}
                              className={style.option}
                              onClick={handleSensorPopup}
                            >
                              <div className={classes.addIcon}>
                                <AddIconLarge />
                                <span style={{ marginLeft: '5px' }}> Add Sensors </span>
                              </div>
                            </Grid>
                            {isAddSensorPopup &&
                              <AddSensors
                                sensorNameChange={handleSensorName}
                                sensorCodeChange={handleSensorCode}
                                handleSave={handleAddSensor}
                                error={sensorErrors}
                              />
                            }
                            {filteredSensors.map((sensor, index) => (
                              <Grid item xs={12} md={12}
                                className={style.option}
                                key={index}
                                onClick={() => handleSensorSelection(sensor.codeValue)}
                              >
                                <span style={{ marginLeft: '10px' }}> {sensor.codeValue} </span>
                              </Grid>
                            ))}
                          </Grid>
                        )}
                        {errors.sensorsError && (
                          <span className="form-error">
                            {errors.sensorsError}
                          </span>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>

              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={12}>
                      <Typography className={style.typo}>
                        Actuators
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className={`cloud-container ${showActuatorPopup ? classes.popup : ''}`}>
                        {showActuatorPopup ? (
                          <label className="no-data-available" style={{ width: "100%" }}>
                            <ActuatorPopup />
                          </label>
                        ) : (
                          <>
                            {actuatorsOfDevice.length === 0 && (
                              <label className="no-data-available" style={{ width: "100%" }}>
                                No Actuator Added
                              </label>
                            )}
                            {actuatorsOfDevice.map((actuator, index) => (
                              <Grid container key={index} className={style.cloudItem}>
                                <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                                <Grid item className={style.cloudItem_line}></Grid>
                                <Grid item className={style.cloudItem_text}>{actuator.name}</Grid>
                                <Grid item onClick={() => removeActuatorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC' /></Grid>
                              </Grid>
                            ))}
                          </>
                        )}
                      </div>
                      {!showActuatorPopup && (
                        <>
                          <FormControl className={`${style.inputProdAdd} actuator-dropdown`} onClick={() => setShowActuatorOptions(prev => !prev)}>
                            <Typography className={style.formInputNew}>
                              <span style={{ color: "grey" }}> Add Actuators </span>
                              {showActuatorOptions ? <UpArrow /> : <DownArrow />}
                            </Typography>
                            {showActuatorOptions && (
                              <Grid container className={classes.dropDownGrid}>
                                <Grid item xs={12} md={12}
                                  className={style.option}
                                  onClick={handleActuatorPopup}
                                >
                                  <div style={{ margin: "0px", display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <AddIconLarge />
                                    <span style={{ marginLeft: '5px' }}> Add Actuators </span>
                                  </div>
                                </Grid>
                                {actuators.map((actuator, index) => (
                                  <Grid item xs={12} md={12}
                                    className={style.option}
                                    key={index}
                                    onClick={() => handleActuatorSelection(actuator.name)}
                                  >
                                    <span style={{ marginLeft: '10px' }}> {actuator.name} </span>
                                  </Grid>
                                ))}
                              </Grid>
                            )}
                            {errors.actuatorsError && (
                              <span className="form-error">
                                {errors.actuatorsError}
                              </span>
                            )}
                          </FormControl>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>

              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={6}>
                      <Typography className={style.typo}>
                        Connectivity
                        <span className={style.required}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <FormControl className={style.input}>
                        <Grid container >
                          <Grid container className={style.formInputNew}
                            style={{ cursor: 'pointer' }}
                            alignContent='center'
                            onClick={() => setIsConnectionDropDown(true)}
                          >
                            <Grid item style={{ flex: 1 }}>
                              <input
                                placeholder="Select Connection"
                                className={classes.optionInput}
                                value={connectivity}
                                onChange={(e) => setConnectivity(e.target.value)}
                              />
                            </Grid>
                            <Grid item> {isConnectionDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                          </Grid>
                          {isConnectionDropDown && (
                            <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                              {connectivityOptions.map((option, index) => {
                                return (
                                  <Grid item className={style.option} key={index}
                                    onClick={() => {
                                      handleConnectivityChange(option)
                                    }}
                                  >
                                    {option}
                                  </Grid>
                                )
                              })
                              }
                            </div>
                          )}
                        </Grid>
                        {errors.connectivityError && (
                          <span className="form-error">
                            {errors.connectivityError}
                          </span>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={6}>
                      <Typography className={style.typo}>
                        Protocol
                        <span className={style.required}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <FormControl className={style.input}>
                        <Grid container >
                          <Grid container className={style.formInputNew}
                            style={{ cursor: 'pointer' }}
                            alignContent='center'
                            onClick={() => setIsProtocolDropDown(true)}
                          >
                            <Grid item style={{ flex: 1 }}>
                              <input
                                placeholder="Select Protocol"
                                className={classes.optionInput}
                                value={protocol}
                                onChange={(e) => setProtocol(e.target.value)}
                              />
                            </Grid>
                            <Grid item> {isProtocolDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                          </Grid>
                          {isProtocolDropDown && (
                            <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                              {protocolOptions.map((option, index) => {
                                return (
                                  <Grid item className={style.option} key={index}
                                    onClick={() => {
                                      handleProtocolChange(option)
                                    }}
                                  >
                                    {option}
                                  </Grid>
                                )
                              })
                              }
                            </div>
                          )}
                        </Grid>
                        {errors.protocolError && (
                          <span className="form-error">
                            {errors.protocolError}
                          </span>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>


              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid container alignItems="center">
                    <Typography className={style.typo}>
                      Persistence
                      <span className={style.required}>* </span>
                      <Tooltip
                        title="Persistence in device end refers to the ability of a device to retain data or settings even after being powered off or restarted ensuring continuity and smooth operation"
                        classes={{ tooltip: classes.questionTooltip }}
                      >
                        <IconButton style={{ padding: "0px" }}>
                          <QuestionIcon />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                    <Grid item xs={12} md={12}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start'
                      }}>
                      <FormControl>
                        <Grid container alignItems="center">
                          <RadioGroup row
                            value={persistenceValue}
                            onChange={(e) => {
                              setSelectedPersistence(e.target.value);
                              setErrors(prevErrors => ({
                                ...prevErrors,
                                persistenceError: null
                              }));
                            }}
                          >
                            <FormControlLabel
                              value="true"
                              control={<Radio className={style.radio} />}
                              label="True"
                            />
                            <FormControlLabel
                              value="false"
                              control={<Radio className={style.radio} />}
                              label="False"
                            />
                          </RadioGroup>
                          {isSubmitted && errors.persistenceError && (
                            <Grid item>
                              <span className="form-error">
                                {errors.persistenceError}
                              </span>
                            </Grid>
                          )}
                        </Grid>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={12}>
                  <Grid container justifyContent="space-between">
                    <Grid item xs={6} md={3} lg={2} style={{flexDirection:"column"}}>
                      <Typography className={style.typo}>
                        OTA Upgradable
                      </Typography>
                        <FormControl>
                        <ReactSwitch
                          checked={!otaUpgradable}
                          onChange={handleChangeOTAToggle}
                          offColor='#D9D9D9'
                          onColor='#2A7CED'
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={20}
                          width={40}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}  md={3} lg={2}style={{flexDirection:"column"}}>
                      <Typography className={style.typo}>
                        Remotely Configurable
                      </Typography>
                      <FormControl>
                        <ReactSwitch
                          checked={!remotelyConfigurable}
                          onChange={handleChangeRemoteToggle}
                          offColor='#D9D9D9'
                          onColor='#2A7CED'
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={20}
                          width={40}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}  md={3} lg={2} style={{flexDirection:"column"}}>
                      <Typography className={style.typo}>
                        Transcoding
                      </Typography>
                      <FormControl>
                        <ReactSwitch
                          checked={!isToggled}
                          onChange={handleChangeToggle}
                          offColor="#D9D9D9"
                          onColor="#2A7CED"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={20}
                          width={40}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={3}></Grid>
              </Grid>

              {!isToggled && (
                <>
                  <Grid item container xs={12} md={12} alignItems="center" style={{ marginBottom: "20px" }}>
                    {errors.codecError && (
                      <span className="form-error">
                        {errors.codecError}
                      </span>
                    )}
                    <Grid container>
                      <Grid item xs={12} md={12}>
                        <Grid container>

                          {/* SELECT CODEC METHOD */}
                          <Grid item xs={12} md={6}
                            onClick={() => setStep("select")}
                            className={`${style.formInputNew} ${style.switchTab}`}
                            style={{
                              borderBottom: step === "select" ? "3px solid #2A7CED" : "1px solid #ccc",
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <span style={{ marginLeft: '8px' }}></span>
                              SELECT CODEC METHOD
                            </div>


                          </Grid>

                          {/* CREATE CODEC */}
                          <Grid item xs={12} md={6}
                            onClick={() => setStep("create")}
                            className={`${style.formInputNew} ${style.switchTab}`}
                            style={{
                              borderBottom: step === "create" ? "3px solid #2A7CED" : "1px solid #ccc",
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <span style={{ marginLeft: '8px' }}></span>
                              CREATE CODEC
                            </div>

                          </Grid>

                        </Grid>
                      </Grid>
                    </Grid>

                  </Grid>

                  {/* create codec form elements */}
                  {step === 'create' && (
                    <Grid item xs={12} md={12} style={{ marginBottom: "20px" }}>
                      <Grid item xs={12} md={12}>
                        <Grid container alignItems="center">
                          <AddNewDecoder
                            onClose={handleSelectCodecClick}
                            codecs={codecs}
                            onCodecToPlaceholder={handleCodecCreation}
                            successCallback={successCallback}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/* select codec form elements */}
                  {step !== 'create' && (
                    <Grid item xs={12} md={12} style={{ marginBottom: "20px" }}>
                      <Grid item xs={12} md={12}>
                        <Grid container alignItems="center">
                          <FormControl className={style.input}>
                            <Grid container >
                              <Grid container className={style.formInputNew}
                                style={{ cursor: 'pointer' }}
                                alignContent='center'
                                onClick={() => setIsCodecDropDown(true)}
                              >
                                <Grid item style={{ flex: 1 }}>
                                  <input
                                    placeholder={codecToSend === '' ? "Select Codec" : codecToSend}
                                    className={classes.optionInput}
                                    value={selectedCodec}
                                    //onChange={() => setIsCodecDropDown(true)}
                                    onChange={(e) => setSelectedCodec(e.target.value)}
                                    readOnly={true}
                                  />
                                </Grid>
                                <Grid item> {isCodecDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                              </Grid>
                              {isCodecDropDown && (
                                <div style={{ width: '100%', zIndex: 1 }}>
                                  <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                                    {codecs.map((codec, index) => {
                                      return (
                                        <Grid item xs={12} md={12}
                                          className={style.option}
                                          key={index}
                                          onClick={() => {
                                            handleCodecChange(codec.codecName)
                                          }}
                                        >
                                          <span style={{ marginLeft: '10px' }}> {codec.codecName} </span>
                                        </Grid>
                                      )
                                    })
                                    }
                                  </div>
                                  <div style={{ marginTop: '20px' }} />
                                </div>
                              )}
                            </Grid>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}</>) 
              : <Step2RemoteOTAConfig
                otaUpgradable={otaUpgradable}
                remotelyConfigurable={remotelyConfigurable}
                dataFormat={dataFormat}
                setDataFormat={setDataFormat}
                errors={errors}
                setErrors={setErrors}
                setParameters={setParameters}
                setRemotelyConfigurable={setRemotelyConfigurable}
                parameters={parameters}
                parametersAddedError={errors.parametersError&&errors.parametersError.length>0}
                parameterError={parameterError}
                setParameterError={setParameterError}
                classes={classes}
                showFeatureUnavailablePopup={showFeatureUnavailablePopup}
                hasPackagePermission={hasPackagePermission}
                setToaster={setToaster}
                setErrorMessage={setErrorMessage}
                setReqSuccess={setReqSuccess}
                setLoading={setLoading}
                setShowNotAvailablePopup={setShowNotAvailablePopup}
                setOpenOTA={setOpenOTA}
                showNotAvailablePopup={showNotAvailablePopup}
                setBinFile={setBinFile} 
                productVersion={productVersion} 
                setProductVersion={setProductVersion}
                setFlowChart={setFlowChart}
                 flowChartName={flowChartName} 
                 setFlowChartName={setFlowChartName}
                flowchartFileList={flowchartFileList} 
                setFlowchartFileList={setFlowchartFileList}
                binError={binError} 
                setBinError={setBinError} 
                versionError={versionError} 
                setVersionError={setVersionError}
                flowChartError={flowChartError} 
                setFlowChartError={setFlowChartError} 
                flowChartNameError={flowChartNameError} 
                setFlowChartNameError={setFlowChartNameError}
                otaAckTopic={otaAckTopic}
                setotaAckTopic={setotaAckTopic}
                rmAckTopic={rmAckTopic}
                setrmAckTopic={setrmAckTopic}
                otaRequestTopic={otaRequestTopic}
                setotaRequestTopic={setotaRequestTopic}
                rmConfigTopic={rmConfigTopic}
                setrmConfigTopic={setrmConfigTopic}
               
              />}
              <Grid item xs={12} md={12}>
        <Grid item xs={12} md={12}>
          <Grid container alignItems="center">
            <Grid item xs={8} md={9}>
              <FormGroup>
                <FormControlLabel
                  label="Add Another Product"
                  control={
                    <Checkbox
                      className={style.radio}
                      checked={addAnotherProduct}
                      onChange={handleCheckboxChange}
                    />
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>
          <Grid container  justifyContent="flex-end" style={{ marginTop:"20px"}}>
          <Button
            className={style.backButton}
            variant="contained"
            color="secondary"
            style={{
              marginRight: '10px'
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          {otaUpgradable && remotelyConfigurable || mainstep === 1 ? 
          <Button 
            className={style.saveButton} 
            variant="contained"
            color="primary"
            style={{

              boxShadow: 'none',
              height:"40px",
             
            }}
            onClick={handleSave}
          >
            Save
          </Button>:          
          <Button 
            className={style.saveButton} 
            variant="contained"
            color="primary"
            style={{

              boxShadow: 'none',
              height:"40px",
             
            }}
            onClick={handleNext}
          >
            Next
          </Button>}
        </Grid>
 </div>
         



      </Grid> 

  
      </Grid>
      <Snackbar
        open={toaster}
        autoHideDuration={6000}
        onClose={handleCloseToaster}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToaster}
          severity={reqSuccess === true ? "success" : "error"}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80} />
        </div>
      }
    </div>


    </ThemeProvider>
  );
}

const local= makeStyles((theme: Theme) => ({
  dropDownGrid: {
    backgroundColor: white,
    border: '1px solid #C7C4C4',
    borderRadius: '5px',
    maxHeight: '200px',
    overflowY: 'auto',
    marginTop: '40px',
    zIndex:10,
    position: 'absolute'
  },
  dropdown: {
    textAlign: 'left',
    border: '1px solid #C7C4C4',
    borderRadius: '5px',
    backgroundColor: white,
    width: '100%',
    zIndex: 1,
    maxHeight: '160px',
    overflowY: 'auto',
  },
  optionInput: {
    cursor: 'pointer',
    border: 'none',
    fontFamily: "'Poppins', sans-serif"
  },
  helperText: {
    color: "red",
    fontSize: "small",
    paddingTop: "7px",
  },
  popup: {
    backgroundColor: "#CEEBCE",
  },
  questionTooltip: {
    backgroundColor: "#334B5A",
    color: 'white',
    borderRadius: '4px',
    padding: '10px',
    fontSize: '12px',
  },
  input: {
    width: "100%",
    textAlign: "left",
  },
  label: {
    fontSize: "15px",
    color: primaryGray,
    paddingBottom: "5px",
  },
  chip: {
    borderRadius: "4px",
    backgroundColor: "#C7C4C436",
    marginLeft: "5px",
  },
  inputDefaultValue: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
  labelDefaultValue: {
    marginBottom: "20px",
  },
  chipDefault: {
    borderRadius: "2px",
    backgroundColor: "#C7C4C436",
    marginLeft: "2px",
    marginBottom: "10px",
  },
  addIcon:{
    margin: "5px 0px 0px 10px",
    display: 'flex', 
    alignItems: 'center', 
    cursor: 'pointer'
  }
  


}));
export default local;
